import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center bg-white/10 rounded-lg p-1 space-x-1">
      {/* Botão Inglês - sempre à esquerda */}
      <button
        onClick={() => changeLanguage('en')}
        className={`flex items-center justify-center w-12 h-8 rounded-md transition-all duration-300 ${
          i18n.language === 'en' 
            ? 'bg-white/20 shadow-lg scale-105 ring-2 ring-white/30' 
            : 'hover:bg-white/10 hover:scale-105'
        }`}
        title="English"
      >
        <span className="text-lg filter drop-shadow-sm">🇺🇸</span>
      </button>
      
      {/* Botão Português - sempre à direita */}
      <button
        onClick={() => changeLanguage('pt')}
        className={`flex items-center justify-center w-12 h-8 rounded-md transition-all duration-300 ${
          i18n.language === 'pt' 
            ? 'bg-white/20 shadow-lg scale-105 ring-2 ring-white/30' 
            : 'hover:bg-white/10 hover:scale-105'
        }`}
        title="Português"
      >
        <span className="text-lg filter drop-shadow-sm">🇧🇷</span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
